import TimeInput from "../TimeInput/TimeInput";
import CurrencyInput from "react-currency-input-field";
import React, { useState } from "react";
import _uniqueId from "lodash/uniqueId";

export const FIELD_TEXT_TYPE = {
  TEXT: `TEXT`,
  CURRENCY: `CURRENCY`,
  TIME: `TIME`,
};

export default function FieldText({
  label = "",
  type = "text",
  placeholder,
  information,
  value,
  style,
  onChange,
  onBlur,
  required = false,
  disabled = false,
  readonly = false,
  classNames = "",
  maxLength = 255,
  error,
  step,
  max,
  min,
  inputClassName = "",
  name = "",
  fieldTextType = FIELD_TEXT_TYPE.TEXT,
  decimalScale = 2,
  allowNegativeValue,
  id,
}) {
  const [uniqueId] = useState(_uniqueId("field_"));

  let field;

  switch (fieldTextType) {
    case FIELD_TEXT_TYPE.CURRENCY:
      field = (
        <CurrencyInput
          decimalsLimit={decimalScale}
          decimalScale={decimalScale}
          allowNegativeValue={allowNegativeValue}
          onValueChange={onChange}
          value={value}
          type={type}
          className={`form-control ${inputClassName}`}
          id={id || uniqueId}
          placeholder={placeholder}
          aria-describedby={(id || uniqueId) + "Help"}
          onBlur={onBlur}
          readOnly={readonly}
          disabled={disabled}
          required={required}
          step={step}
          min={min}
          max={max}
          name={name}
          intlConfig={{ locale: "en-US", index: 100 }}
        />
      );
      break;
    case FIELD_TEXT_TYPE.TIME:
      field = (
        <TimeInput
          name="time"
          initTime={value}
          className={`form-control ${inputClassName}`}
          mountFocus="true"
          id={id || uniqueId}
          // onTimeChange={onChange}
          // onBlurHandler={onBlur}
        />
      );
      break;

    default:
      field = (
        <input
          maxLength={maxLength}
          value={value}
          type={type}
          className={`form-control ${inputClassName}`}
          id={id || uniqueId}
          placeholder={placeholder}
          aria-describedby={(id || uniqueId) + "Help"}
          onChange={onChange}
          onBlur={onBlur}
          readOnly={readonly}
          disabled={disabled}
          required={required}
          step={step}
          min={min}
          max={max}
          name={name}
        />
      );
      break;
  }

  return (
    <div className={"form-group " + classNames} style={style}>
      {label && <label htmlFor={id || uniqueId}>{label}</label>}
      {field}
      {information ? (
        <small id={(id || uniqueId) + "Help"} className="form-text text-muted">
          {information}
        </small>
      ) : null}
      {error ? (
        <div className="invalid-feedback" style={{ display: "block" }}>
          {error}
        </div>
      ) : null}
    </div>
  );
}
